module.exports = __webpack_public_path__ + "img/home-quotation-blue.1bb8210d.png";